import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {BlogState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class BlogQuery extends QueryEntity<BlogState> {

  constructor(protected store: Store) {
    super(store);
  }

}
